import { apiClient } from './api'

export type GuestScope = 'project' | 'task'
export type GuestPermission = 'read' | 'comment'

export interface GuestInvite {
  id: number
  email: string
  scope_entity: GuestScope
  scope_id: number
  permission: GuestPermission
  expires_at: string
  accepted_at?: string | null
  revoked: boolean
  invite_url: string
}

export interface InviteCreateInput {
  email: string
  scope_entity: GuestScope
  scope_id: number
  permission?: GuestPermission
  expires_in_days?: number
}

export const guestsService = {
  list: async (scope: GuestScope, scopeId: number): Promise<GuestInvite[]> => {
    const { data } = await apiClient.get('/api/v1/guests/invites', {
      params: { scope_entity: scope, scope_id: scopeId },
    })
    return data
  },
  create: async (input: InviteCreateInput): Promise<GuestInvite> => {
    const { data } = await apiClient.post('/api/v1/guests/invites', input)
    return data
  },
  revoke: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/guests/invites/${id}`)
  },

  // Public (token-based) routes — no auth header needed.
  redeem: async (token: string) => {
    const { data } = await apiClient.post(`/api/v1/guests/redeem/${token}`)
    return data as {
      scope_entity: GuestScope
      scope_id: number
      permission: GuestPermission
      expires_at: string
      email: string
    }
  },
  view: async (token: string) => {
    const { data } = await apiClient.get(`/api/v1/guests/view/${token}`)
    return data
  },
  comment: async (token: string, content: string) => {
    const { data } = await apiClient.post(`/api/v1/guests/view/${token}/comments`, { content })
    return data
  },
}
